// Reuse the existing tag/consent integration; never send the Viber invite token.
document.addEventListener('click', function (event) {
  var link = event.target && event.target.closest && event.target.closest('[data-track="city_hub_viber_click"]');
  if (!link || typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', 'city_hub_viber_click', {
      place_id: link.getAttribute('data-place-id'), page_type: 'show', placement: 'city_hub_pilot', transport_type: 'beacon'
    });
  } catch (_) { /* A blocked analytics call must not prevent navigation. */ }
});
